<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Vouchers</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link> / <b>Loyalty Point System</b> / <b>Vouchers</b> /
      <b>Products</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <!-- Graph -->
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <div class="row">
              <!-- TBA Graph -->
              <div class="col-6">
                <button class="btn btn-primary" @click="printTba">Print</button>
                <div id="printTbaGraph">
                  <div id="monthly">
                    <h4 class="text-center">
                      <b>TBA Vouchers Redeemed for Year {{ year }}</b>
                    </h4>

                    <GChart
                      type="ColumnChart"
                      :data="tbaData"
                      :options="tbaOptions"
                    />
                  </div>
                </div>
              </div>
              <!-- TBA Graph -->

              <!-- TBK Graph -->
              <div class="col-6">
                <button class="btn btn-primary" @click="printTbk">Print</button>
                <div id="printTbkGraph">
                  <div id="monthly">
                    <h4 class="text-center">
                      <b>TBK Vouchers Redeemed for Year {{ year }}</b>
                    </h4>

                    <GChart
                      type="ColumnChart"
                      :data="tbkData"
                      :options="tbkOptions"
                    />
                  </div>
                </div>
              </div>
              <!-- TBK Graph -->
            </div>

            <div class="row" style="margin-top: 50px">
              <!-- Discount Token Graph -->
              <div class="col-3"></div>
              <div class="col-6">
                <button class="btn btn-primary" @click="printDiscountToken">
                  Print
                </button>
                <div id="printDiscountTokenGraph">
                  <div id="monthly">
                    <h4 class="text-center">
                      <b>Discount Tokens Redeemed for Year {{ year }}</b>
                    </h4>

                    <GChart
                      type="PieChart"
                      :data="discountTokenData"
                      :options="discountTokenOptions"
                    />
                  </div>
                </div>
              </div>
              <!-- Discount Token Graph -->
            </div>
          </div>

          <hr />

          <div
            class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
          >
            <span class></span>
            <!-- Year -->
            <div class="col-6">
              <div class="form-group">
                <label>Filter by Year</label>
                <select class="form-control" v-model="filter_year">
                  <option v-for="(year, index) in years" :key="index">
                    {{ year }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <button class="btn btn-primary" @click="applyFilter()">
                  Filter
                </button>
                &nbsp;
                <button
                  id="btnAll"
                  class="btn btn-primary d-none"
                  @click="removeFilter()"
                >
                  All
                </button>
              </div>
            </div>
          </div>

          <hr />
        </div>
      </div>
      <!-- Graph -->

      <!-- Table -->
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <div class="table-responsive">
              <table
                id="voucher_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th width="5%">No.</th>
                    <th>Product Name</th>
                    <th width="10%">Redeemed Qty</th>
                    <th width="10%">Used Qty</th>
                    <th width="10%">Usable Qty</th>
                    <th width="10%">Accumulated Points</th>
                    <th width="10%">Total Price B$</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in products" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ product.takaful_product }}</td>
                    <td>{{ product.redeemed }}</td>
                    <td>{{ product.used }}</td>
                    <td>
                      {{ product.usable_quantity }}
                      <br />
                      <button
                        v-if="
                          product.usable_quantity != 0 &&
                          product.takaful_product_id != 53
                        "
                        @click="convert(product)"
                        class="btn btn-primary btn-rounded btn-block"
                      >
                        Convert to Discount Token
                      </button>
                    </td>
                    <td>{{ product.total_points.replace(".00", "") }}</td>
                    <td>{{ product.total_cost }}</td>
                    <td>
                      <router-link
                        :to="redirect(product.takaful_product_id)"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Vouchers</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Table -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  name: "voucher-product",
  components: {
    GChart,
  },

  data() {
    return {
      products: [],

      tbaData: [],
      tbaOptions: {
        height: 300,
        legend: "none",
        vAxis: {
          title: "No Vouchers Redeemed",
          textStyle: {
            fontSize: 12,
            bold: true,
          },
          titleTextStyle: {
            fontSize: 14,
            bold: true,
          },
        },
        hAxis: {
          textStyle: {
            fontSize: 8,
            bold: true,
            color: "#848484",
          },
        },
      },

      tbkData: [],
      tbkOptions: {
        height: 300,
        legend: "none",
        vAxis: {
          title: "No Vouchers Redeemed",
          textStyle: {
            fontSize: 12,
            bold: true,
          },
          titleTextStyle: {
            fontSize: 14,
            bold: true,
          },
        },
        hAxis: {
          textStyle: {
            fontSize: 8,
            bold: true,
            color: "#848484",
          },
        },
      },

      discountTokenData: [],
      discountTokenOptions: {
        pieHole: 0.5,
        height: 500,
        legend: "bottom",
        pieSliceText: "value",
        colors: ["#dabf69", "#b38900"],
      },

      year: 0,
      years: [],
      filter_year: "",
    };
  },

  methods: {
    async loadProducts() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(
            axios.lpsURL + "/voucher/takaful/products",
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );
          this.products = result.data.products;
          this.tbaData = result.data.tba_graph;
          this.tbkData = result.data.tbk_graph;
          this.discountTokenData = result.data.discount_token_chart;
        } catch (error) {
          console.log(error);
        }
      }
    },

    createDatatable() {
      $("#voucher_tbl").DataTable({
        pageLength: 15,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4],
            },
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4],
            },
          },
        ],
      });
    },

    redirect(takaful_product_id) {
      return "/lps/voucher/product/" + takaful_product_id;
    },

    printTba() {
      // Pass the element id here
      this.$htmlToPaper("printTbaGraph");
    },

    printTbk() {
      // Pass the element id here
      this.$htmlToPaper("printTbkGraph");
    },

    printDiscountToken() {
      // Pass the element id here
      this.$htmlToPaper("printDiscountTokenGraph");
    },

    loadYearFilter() {
      let date = new Date();
      let start_date = 2020;
      let current_year = date.getFullYear();

      this.year = current_year;

      // Past 5 year
      for (let i = start_date; i < current_year + 1; i++) {
        this.years.push(i);
      }
    },

    applyFilter() {
      $("#btnAll").removeClass("d-none");

      // Declare filters
      let year = "";

      if (this.filter_year.length != 0) {
        year = "?filter_year=" + this.filter_year;
        this.year = this.filter_year;
      }

      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/voucher/takaful/products" + year, {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((result) => {
            this.products = result.data.products;
            this.tbaData = result.data.tba_graph;
            this.tbkData = result.data.tbk_graph;
          });
      }
    },

    removeFilter() {
      $("#btnAll").addClass("d-none");

      this.filter_year = "";
      this.years = [];

      this.loadYearFilter();
      this.loadProducts();
    },

    async convert(product) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.post(
            axios.lpsURL + "/lps/voucher/convert/" + product.vendor_product_id + "/multiple",
            {
              usable_quantity: product.usable_quantity,
            },
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );

          swal({
            icon: result.data.success ? "success" : "error",
            text: result.data.message,
          }).then(() => {
            window.location.reload();
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
  },

  async created() {
    await this.loadProducts();
    this.createDatatable();
    this.loadYearFilter();
  },

  mounted() {},
};
</script>
